import $ from 'jquery';

// main page script
const main = {
	gnb: () => {
		const body = $('body');
		const header = $('.header');
		const navList = $('.main-menu > li');
		const navItems = $('.main-menu > li > a');
		const navClose = $('.nav .nav-close');
		const navOpen = $('.header .utils .button_menu');

		// 즉시 실행
		header.addClass('init');
		const depth2Item = navList.find('.sub-menu-wrap > .sub-menu > li > a');
		depth2Item.each(function () {
			if ($(this).next().length === 0) $(this).addClass('sub-title-link');
		});
		const depth3Item = navList.find('.sub-menu-wrap > .sub-menu > li > .sub-menu > li > a');
		depth3Item.each(function () {
			if ($(this).next().length !== 0) $(this).addClass('sub-list-button');
		});
		const lastDepth = navList.find('.sub-menu-wrap > .sub-menu > li > .sub-menu > li > .sub-menu > li.current-menu-item');
		lastDepth.each(function () {
			$(this).parent().parent().addClass('sub-active');
		});

		//
		navList.on('mouseover', function () {
			if (body.hasClass('nav-opens')) return;
			if (!body.hasClass('nav-hover')) body.addClass('nav-hover');
		});

		header.on('mouseleave', function () {
			if (body.hasClass('nav-opens')) return;
			body.removeClass('nav-hover');
		});

		navItems.on('mouseover', function () {
			if (window.innerWidth <= 1300) return;
			navItems.parent().removeClass('menu-active');
			$(this).parent().addClass('menu-active');
		});

		const subButton = $('.nav .sub-list-button');
		subButton.on('click', function () {
			const item = $(this).parent();
			if (item.hasClass('sub-active')) {
				item.removeClass('sub-active');
			} else {
				subButton.parent().removeClass('sub-active');
				item.addClass('sub-active');
			}
			return false;
		});

		navItems.on('click', function () {
			if (window.innerWidth > 1024) return;
			if (!$(this).parent().is('.go-link, .direct-link')) {
				if (!$(this).parent().hasClass('menu-open')) {
					$(this).parent().siblings().removeClass('menu-open');
					$(this).parent().addClass('menu-open');
				}
				return false;
			}
		});

		navOpen.on('click', function () {
			body.addClass('nav-opens');

			let hasCurrent = false;
			navList.each(function (index) {
				if ($(this).hasClass('current-menu-ancestor')) {
					$(this).addClass('menu-open');
					return (hasCurrent = true);
				}
			});
			// 선택된 페이지가 없으면 제일 처음 메뉴를 보여줘라
			if (!hasCurrent) {
				navList.eq(0).addClass('menu-open');
			}
			lastDepth.each(function () {
				$(this).closest('.sub-list-item').addClass('sub-active');
			});
		});
		navClose.on('click', function () {
			body.removeClass('nav-opens');
		});
	},
	gnbScroll: () => {
		const visual = $('.sub-visual');
		if (visual.length === 0) {
			$('body').addClass('nav-no-visual');
		}
		const subSize = visual.length === 0 ? 0 : visual.innerHeight();
		const scrollTop = $(window).scrollTop();
		if (scrollTop > subSize) {
			$('body').addClass('nav-scrolled');
		} else {
			$('body').removeClass('nav-scrolled');
		}
	},
	searchLayer: () => {
		const open = $('.header .utils .button_search');
		const close = $('.search_form .close');
		const body = $('body');

		open.on('click', function () {
			body.addClass('search-opens');
			$('.search_form input').focus();
		});
		close.on('click', function () {
			body.removeClass('search-opens');
			open.focus();
		});
	},
	breadcrumb: () => {
		// fixed
		const body = $('body');
		const bread = $('#breadcrumb');
		const top = bread.offset().top;
		const scrollTop = $(window).scrollTop();
		if (scrollTop > top) {
			body.addClass('breadcrumb-fixed');
		} else {
			body.removeClass('breadcrumb-fixed');
		}
	},
	breadcrumbLink: () => {
		// 링크 클릭
		const breadMenus = $('#breadcrumb .link');
		breadMenus.on('click', function (event) {
			event.stopPropagation();
			const windowWidth = window.innerWidth;
			const box = $(this).siblings('.list_box');
			if (box.hasClass('hidden')) {
				box.closest('.breadcrumb_item').find('.list_box').addClass('hidden');
				box.removeClass('hidden');
				// 화면 밖으로 나갔을때...
				const left = box.offset().left;
				const boxWidth = box.width();
				if (windowWidth < left + boxWidth) {
					const posLeft = windowWidth - left - boxWidth - 2;
					box.css('left', posLeft);
				}
			} else {
				box.addClass('hidden');
				box.removeAttr('style');
			}
		});
		$(document).on('click', function (event) {
			const list = $('#breadcrumb .list_box');
			if (list.has(event.target).length === 0) {
				list.addClass('hidden');
				list.removeAttr('style');
			}
		});
	},
	breadcrumbMobile: () => {
		const wrap = $('.breadcrumb_wrap');
		const wrapWidth = wrap.width() - 20 - $('.breadcrumb_wrap .home').width();
		let number = [];
		let ellipsis = 26;
		wrap.find('.menu').removeClass('word-ellipsis');
		if (window.innerWidth > 1024) return;
		wrap.find('.menu-wrap')
			.children()
			.each(function () {
				number.push(Math.round($(this).width()));
			});
		const result = adjustArray(wrapWidth, number);
		result.forEach(function (item, index) {
			if (item === ellipsis) {
				wrap.find('.menu').eq(index).addClass('word-ellipsis');
			}
		});

		// 화면너비에서 브래드크럼의 전체너비의 합이 넘치면 첫요소부터 26(줄였을때 너비)로 줄이면서 다시 계산
		// 마지막요소를 제외하고 줄이는 함수
		function adjustArray(width, array) {
			const lastValue = array[array.length - 1];
			if (array.length < 2) return array;
			let newArray = array.slice(0, -1);
			newArray.push(lastValue);
			let totalWidth = newArray.reduce((sum, val) => sum + val, 0);
			for (let i = 0; i < newArray.length - 1; i++) {
				if (totalWidth <= width) break;
				const diff = newArray[i] - ellipsis;
				newArray[i] = ellipsis;
				totalWidth -= diff;
			}
			if (totalWidth > width) {
				console.warn('Array cannot be adjusted to fit within the width.');
			}
			return newArray;
		}
	},

	// 메인페이지
	mainSlideVisual: () => {
		// 최상단 비주얼 슬라이드
		const $slider = $('.visual-slide').slick({
			arrows: true,
			dots: true,
			infinite: true,
			autoplay: false,
			fade: true,
			appendDots: $('.visual-slide-utils .dots'),
			customPaging: function (slider, i) {
				return `<button><span>${i + 1}</span> / ${slider.slideCount}</button>`;
			},
			responsive: [
				{
					breakpoint: 769,
					settings: {
						arrows: false,
					},
				},
			],
		});

		const $progressBar = $('.section-index-visual .progress-bar');
		let isPaused = false;

		function resetProgressBar() {
			$progressBar.css('transition', `width 0ms linear`);
			$progressBar.css('width', '0%');
		}
		function startProgressBar(duration) {
			resetProgressBar();
			setTimeout(function () {
				$progressBar.css('transition', `width ${duration}ms linear`);
				$progressBar.css('width', '100%');
			}, 100);
		}

		function handleVideoProgress(video) {
			const duration = video.duration * 1000 - 100;
			startProgressBar(duration);
			$(video)
				.off('ended')
				.on('ended', function () {
					if (!isPaused) $slider.slick('slickNext');
				});
		}

		function stopAllVideos() {
			$('.slide-video').each(function () {
				this.pause();
				this.currentTime = 0;
			});
		}

		$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			stopAllVideos();
			resetProgressBar();
		});

		$slider.on('afterChange', function (event, slick, currentSlide) {
			resetProgressBar();
			const $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
			if ($currentSlide.find('.slide-video').length) {
				const video = $currentSlide.find('.slide-video')[0];
				video.play();
				handleVideoProgress(video);
			}

			const buttonControls = $('.slide-controls');
			if (buttonControls.hasClass('stop')) buttonControls.removeClass('stop');
		});

		// Initialize first slide
		const firstSlideIndex = $slider.slick('slickCurrentSlide');
		const $firstSlide = $slider.find('.slick-slide[data-slick-index="' + firstSlideIndex + '"]');
		if ($firstSlide.find('.slide-video').length) {
			const video = $firstSlide.find('.slide-video')[0];
			video.play();
			setTimeout(function () {
				handleVideoProgress(video);
				$('.visual-slide-title, .section-index-visual').addClass('init');
			}, 100);
		}

		$('.slide-controls').on('click', function () {
			// 기본은 play, stop 가 붙으면 멈춤상태
			if (!$(this).hasClass('stop')) {
				isPaused = true;
				$(this).addClass('stop');

				// 비디오도 멈춰
				stopAllVideos();
				$progressBar.css('transition', 'inherit');
				$progressBar.css('width', '100%');
			} else {
				isPaused = false;
				$(this).removeClass('stop');
				const currentSlideIndex = $slider.slick('slickCurrentSlide');
				const $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlideIndex + '"]');
				if ($currentSlide.find('.slide-video').length) {
					const video = $currentSlide.find('.slide-video')[0];
					if (video.paused) {
						video.play();
						handleVideoProgress(video);
					}
				} else {
					$slider.slick('slickNext');
				}
			}
		});
	},
	mainSlideNews: () => {
		$('.news-slide').slick({
			arrows: false,
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 560,
					settings: {
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
			],
		});
		$('.story-slide').slick({
			arrows: false,
			dots: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 560,
					settings: {
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 769,
					settings: {
						dots: true,
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
			],
		});
	},
	mainCounter: () => {
		const animated = new Set(); // 애니메이션 완료된 요소 저장

		// 숫자 애니메이션 함수
		function animateNumber($element, target, duration = 1200) {
			$({ current: 0 }).animate(
				{ current: target },
				{
					duration: duration,
					step: function (now) {
						$element.text(Math.floor(now).toLocaleString());
					},
				},
			);
		}

		// 쉼표 제거 후 숫자로 변환하는 함수
		function parseNumber(stringNumber) {
			return parseInt(stringNumber.replace(/,/g, ''), 10);
		}

		// 스크롤 이벤트로 요소가 화면에 들어왔는지 확인
		$(window).on('scroll', function () {
			$('.js-counter').each(function () {
				const $this = $(this);
				const offsetTop = $this.offset().top;
				const windowBottom = $(window).scrollTop() + $(window).height();

				if (windowBottom > offsetTop && !animated.has(this)) {
					const rawTarget = $this.data('number'); // "250,123"과 같은 문자열
					const target = parseNumber(rawTarget); // 쉼표 제거 후 숫자로 변환
					animated.add(this); // 중복 애니메이션 방지
					animateNumber($this, target);
				}
			});
		});
	},

	init: () => {
		main.gnb();
		main.searchLayer();
		main.gnbScroll();
		$(window).on('scroll', function () {
			main.gnbScroll();
		});

		// 메인 전용
		if ($('.section-index').length > 0) {
			main.mainSlideVisual();
			main.mainSlideNews();
			main.mainCounter();
		}

		// 브래드크럼 있을때만 실행하시오
		if ($('#breadcrumb').length > 0) {
			main.breadcrumb();
			main.breadcrumbLink();
			main.breadcrumbMobile();

			function debounce(func, wait) {
				let timeout;
				return function (...args) {
					const context = this;
					clearTimeout(timeout);
					timeout = setTimeout(() => func.apply(context, args), wait);
				};
			}

			$(window).on('scroll', function () {
				main.breadcrumb();
			});
			$(window).on(
				'resize',
				debounce(function () {
					main.breadcrumbMobile();
				}, 200),
			);
		}
	},
};

export { main };
